import { useEffect, useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import DOMPurify from "dompurify";
import * as c from "./OfferModalDescriptionTask.module.css";

interface OfferModalDescriptionTaskProps {
  description: string[];
  isMobileOs: string;
}

const OfferModalDescriptionTask = ({ description, isMobileOs }: OfferModalDescriptionTaskProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const characterLimit = isMobileOs == "" ? 150 : 115;

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const fullDescription = description.join(" ");
  const sanitizedFullDescription = DOMPurify.sanitize(fullDescription);

  const truncatedDescription =
    fullDescription.length > characterLimit
      ? DOMPurify.sanitize(fullDescription.slice(0, characterLimit) + "...")
      : sanitizedFullDescription;

  useEffect(() => {
    setShowButton(fullDescription.length > characterLimit);
  }, [fullDescription, characterLimit]);

  return (
    <div className={c.task}>
      <div className={`${c["task-content-container"]} ${isExpanded ? c.expanded : ""}`}>
        {!isExpanded && (
          <div
            className={c.descriptionText}
            dangerouslySetInnerHTML={{ __html: truncatedDescription }}
          />
        )}
        {isExpanded && (
          <div
            className={c["description-text-expanded"]}
            dangerouslySetInnerHTML={{ __html: sanitizedFullDescription }}
          />
        )}
        {showButton && (
          <button onClick={toggleExpanded} className={c["read-more-button"]}>
            {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
            {isExpanded ? "Read Less" : "Read More"}
          </button>
        )}
      </div>
    </div>
  );
};

export default OfferModalDescriptionTask;
